import { render, staticRenderFns } from "./DynamicPage.vue?vue&type=template&id=af8f80ba&"
import script from "./DynamicPage.vue?vue&type=script&lang=ts&"
export * from "./DynamicPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports